
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1601Row.Fields;
    @Serenity.Decorators.registerClass()
    export class Report_1601Grid extends Serenity.EntityGrid<Report_1601Row, any> {
        protected getColumnsKey() { return Report_1601Columns.columnsKey; }
        protected getDialogType() { return Report_1601Dialog; }
        protected getIdProperty() { return Report_1601Row.idProperty; }
        protected getInsertPermission() { return Report_1601Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1601Row.localTextPrefix; }
        protected getService() { return Report_1601Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)
        
           let descriptions: string[] = [];
        //    let shop = QRreport.QRywcSpecRow.getLookup().itemById["20"].ShopId;
            let find = QRreport.QRywcSpecRow.getLookup().itemById["60"].DayOfWeek;
            
            let startDate = QRreport.QRywcSpecRow.getLookup().itemById["60"].DateBegin;
            let endDate = QRreport.QRywcSpecRow.getLookup().itemById["60"].DateEnd;
            let qstartDate = Q.formatDate(startDate, "dd/MM/yyyy")
            let qendDate = Q.formatDate(endDate, "dd/MM/yyyy")
            var a = ""
            
                a = "ระหว่างวันที่ " + qstartDate + " - " + qendDate
        
            
            var b = ""
        
            if (find != null) {
                let pos = QRreport.QDayDataRow.getLookup().itemById[find].DayName;
                b = a + "  ระบุเฉพาะวัน " + pos
        
            } else {
        
                b = a
        
            }
            descriptions.push(b);
            
            return [descriptions, gridColumns];
        }

        protected createQuickSearchInput() {
        }
        
        protected getColumns() {
            var columns = super.getColumns();
        
            return columns;
        }
        
        protected usePager() {
            return false;
        }
        
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
            groupingMixin.plugin.setDroppedGroups(["ShopId"]);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();
            
        }

        protected getButtons() {
            var buttons = super.getButtons();
        
            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
        
            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1601Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
        
            // let reportTitle = 'รายงานสรุปยอดขายสินค้ารับฝากขายร้านค้า&สินค้า'
        
            // // Max page width = 277
            // let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
            //     // 0: { field: "ShopName", title: "ร้านค้า[Id]", cellWidth: 50 ,isHidden:true},
            //     0: { field: "DocDate", title: "วันที่", cellWidth: 67 },
            //     // 2: { field: "ShopId", title: "ร้านค้า", cellWidth: 15 ,isHidden:true},
            //     1: { field: "DayOfWeek", title: "วัน", cellWidth: 15 ,isHidden:true},
            //     2: { field: "GrossSales", title: "ยอดขายก่อนลด", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     3: { field: "AllItemDiscount", title: "ยอดส่วนลดทั้งหมด", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     4: { field: "NetSales", title: "ยอดขายสุทธิ", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     5: { field: "NetSalesExVat", title: "ยข. สุทธิหักVAT", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     6: { field: "VatOfNetSales", title: "VAT(ยอดขาย)", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     7: { field: "AllItemCharge", title: "ต่าชาร์จ", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     8: { field: "VatOfCharge", title: "VAT(ค่าชาร์จ)", cellWidth: 30,halign: 'right',aggregate:"sum"},
            // }
        
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
        
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
        
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
        
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
        
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec1601/edit/60';
                        return false;
                    },
                }
            );
        
            return buttons;
        }
    }
}